import React from 'react';
import styled, { css } from 'styled-components';
import iconNotificationError from '../../assets/notification-error.svg';
import iconNotificationInfo from '../../assets/notification-info.svg';
import iconNotificationSuccess from '../../assets/notification-success.svg';

const NotificationWrapper = styled.div`
  position: relative;
`;

const NotificationType = styled.div<{ type: string }>`
  display: flex;
  min-height: 48px;
  border-radius: 2px;
  overflow: hidden;
  background-color: var(--porcelain);

  ${(props) =>
    props.type === 'success' &&
    css`
      .content {
        border-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.green},
            ${({ theme }) => theme.colors.jade}
          )
          1;
      }
    `}

  ${(props) =>
    props.type === 'warning' &&
    css`
      .content {
        border-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.orange},
            ${({ theme }) => theme.colors.yellow}
          )
          1;
      }
    `}

  ${(props) =>
    props.type === 'error' &&
    css`
      .content {
        border-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.red},
            ${({ theme }) => theme.colors.ruby}
          )
          1;
      }
    `}

    ${(props) =>
    props.type === 'information' &&
    css`
      .content {
        border-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.brandBlue},
            ${({ theme }) => theme.colors.sky}
          )
          1;
      }
    `}
`;

const Icon = styled.div<{ type: string }>`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.type === 'success' &&
    css`
      background-image: linear-gradient(
        to bottom,
        ${({ theme }) => theme.colors.green},
        ${({ theme }) => theme.colors.jade}
      );
    `}
  ${(props) =>
    props.type === 'warning' &&
    css`
      background-image: linear-gradient(
        to bottom,
        ${({ theme }) => theme.colors.orange},
        ${({ theme }) => theme.colors.yellow}
      );
    `}
  ${(props) =>
    props.type === 'error' &&
    css`
      background-image: linear-gradient(
        to bottom,
        ${({ theme }) => theme.colors.red},
        ${({ theme }) => theme.colors.ruby}
      );
    `}
    ${(props) =>
    props.type === 'information' &&
    css`
      background-image: linear-gradient(
        to bottom,
        ${({ theme }) => theme.colors.brandBlue},
        ${({ theme }) => theme.colors.sky}
      );
    `}
`;

const Content = styled.div`
  font-size: 14px;
  color: var(--graphite-90);
  width: 100%;
  padding: 16px 20px;
  border: 1px solid transparent;
  display: inline-block;
  ul {
    display: inherit;
    padding: 0;
    list-style: none;
  }
  ul li {
    padding: 3px 0;
    color: ${({ theme }): string => {
      return theme.colors.brandBlue90Alpha;
    }};
  }
  ul li:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const BannerWrapper = styled.div``;

export function Notification(props: {
  type: string;
  children: React.ReactNode;
}): React.ReactElement {
  const { type, children } = props;

  return (
    <NotificationWrapper>
      <NotificationType type={type}>
        <Icon type={type}>
          <img
            alt="notification-icon"
            src={
              (type === 'success' && iconNotificationSuccess) ||
              (type === 'error' && iconNotificationError) ||
              (type === 'information' && iconNotificationInfo) ||
              (type === 'warning' && iconNotificationInfo) ||
              ''
            }
          />
        </Icon>
        <Content className="content">{children}</Content>
      </NotificationType>
    </NotificationWrapper>
  );
}
